module.exports = __webpack_public_path__ + "static/media/eye-color.6f7426aa.svg";